import React from 'react';
import { Button } from './ui/Button';
import { CheckIcon, InfoIcon, SparklesIcon, ClockIcon } from 'lucide-react';
const pricingTiers = [{
  name: 'Monthly',
  subtitle: 'Flexible option',
  originalPrice: '$25',
  price: '$12.50',
  period: '/month',
  savingsInfo: 'Cancel anytime',
  highlighted: false,
  features: ['2 admins', 'Unlimited reviewers', 'Unlimited contributors', 'Unlimited categories', 'Basic analytics', 'Advanced collaboration (roles)', 'Email & chat support', 'Dedicated success manager', '1 GB storage'],
  buttonText: 'Subscribe Monthly'
}, {
  name: 'Yearly',
  subtitle: 'Best value',
  originalPrice: '$239',
  price: '$119.50',
  period: '/year',
  savingsInfo: '$9.95/month (Save 60%)',
  highlighted: true,
  features: ['2 admins', 'Unlimited reviewers', 'Unlimited contributors', 'Unlimited categories', 'Basic analytics', 'Advanced collaboration (roles)', 'Email & chat support', 'Dedicated success manager', '1 GB storage'],
  buttonText: 'Subscribe Yearly'
}];
export function Pricing() {
  return <section id="pricing" className="py-20 bg-white" data-id="element-348">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-349">
        <div className="text-center mb-10" data-id="element-350">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-[#9333EA] to-[#7B2D7B] text-white text-sm font-bold rounded-full mb-6 shadow-lg animate-pulse" data-id="element-351">
            <SparklesIcon className="h-4 w-4" data-id="element-352" />
            <span data-id="element-353">LIMITED TIME OFFER — 50% OFF ALL PLANS</span>
            <SparklesIcon className="h-4 w-4" data-id="element-354" />
          </div>
          <span className="inline-block px-4 py-1 bg-[#F5E6F5] text-[#9333EA] text-sm font-medium rounded-full mb-4 border border-[#E5B3E5] shadow-sm ml-2" data-id="element-355">
            Pricing Plans
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-356">
            Simple, transparent <span className="text-[#9333EA]" data-id="element-357">pricing</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-6" data-id="element-358">
            Choose the plan that fits your community's needs and scale as you
            grow.
          </p>
          <div className="inline-flex items-center gap-2 text-sm text-[#9333EA] font-semibold bg-[#F5E6F5] px-4 py-2 rounded-full border border-[#E5B3E5]" data-id="element-359">
            <ClockIcon className="h-4 w-4" data-id="element-360" />
            <span data-id="element-361">Offer ends soon — Lock in 50% off today!</span>
          </div>
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 mt-8" data-id="element-362">
            <Button size="lg" className="min-w-[180px] shadow-md" href="https://nexioapp.eu/dashboard/register" data-id="element-363">
              Start your free trial
            </Button>
            <Button variant="outline" size="lg" className="min-w-[180px]" href="https://calendar.app.google/6fKsGXEmBQzjPvnc9" data-id="element-364">
              Plan a Demo
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mt-12" data-id="element-365">
          {pricingTiers.map((tier, index) => {
          const isHighlighted = tier.highlighted;
          return <div key={index} className={`relative rounded-xl overflow-hidden border-2 transition-all duration-300 hover:shadow-lg ${isHighlighted ? 'border-[#9333EA] shadow-lg scale-105 bg-gradient-to-b from-purple-50 to-white' : 'border-[#9333EA] shadow hover:border-[#E5B3E5] bg-white'}`} data-id="element-366">
                <div className="absolute top-3 right-3 z-10 bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-md rotate-3" data-id="element-367">
                  50% OFF
                </div>
                {isHighlighted && <div className="bg-[#9333EA] text-white text-center py-2 text-sm font-medium shadow-md" data-id="element-368">
                    Best Value
                  </div>}
                <div className="p-6" data-id="element-369">
                  <h3 className={`text-xl font-bold ${isHighlighted ? 'text-[#9333EA]' : 'text-gray-900'} mb-1`} data-id="element-370">
                    {tier.name}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm" data-id="element-371">{tier.subtitle}</p>
                  <div className="mb-2 bg-gray-50 p-4 rounded-lg shadow-inner border border-gray-100" data-id="element-372">
                    <div className="flex items-baseline gap-2 flex-wrap" data-id="element-373">
                      <span className="text-lg text-gray-400 line-through" data-id="element-374">
                        {tier.originalPrice}
                      </span>
                      <span className={`text-4xl font-bold ${isHighlighted ? 'text-[#9333EA]' : 'text-gray-900'}`} data-id="element-375">
                        {tier.price}
                      </span>
                      <span className="text-gray-600" data-id="element-376">{tier.period}</span>
                    </div>
                    <div className="mt-2 inline-block bg-red-100 text-red-700 text-xs font-bold px-2 py-1 rounded" data-id="element-377">
                      You save 50%
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 rounded-lg mb-6 shadow-sm" data-id="element-378">
                    <p className={`text-sm font-medium ${isHighlighted ? 'text-[#9333EA]' : 'text-gray-700'}`} data-id="element-379">
                      {tier.savingsInfo}
                    </p>
                  </div>
                  <ul className="space-y-3 mb-8 bg-gray-50 p-4 rounded-lg shadow-sm" data-id="element-380">
                    {tier.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-start" data-id="element-381">
                        <CheckIcon className={`h-5 w-5 ${isHighlighted ? 'text-[#9333EA]' : 'text-[#E5B3E5]'} mr-2 flex-shrink-0`} data-id="element-382" />
                        <span className="text-gray-700 text-sm" data-id="element-383">{feature}</span>
                      </li>)}
                  </ul>
                  <div className="space-y-3" data-id="element-384">
                    <a href="https://nexioapp.eu/dashboard/register" className={`w-full inline-flex items-center justify-center font-medium rounded-lg px-4 py-2 transition-colors ${isHighlighted ? 'bg-[#9333EA] text-white hover:bg-[#7B2D7B]' : 'border border-[#9333EA] text-[#9333EA] hover:bg-[#F5E6F5]'}`} data-id="element-385">
                      {tier.buttonText}
                    </a>
                    <Button variant="ghost" className="w-full" data-id="element-386">
                      Learn More
                    </Button>
                  </div>
                </div>
              </div>;
        })}
        </div>
        <div className="mt-10 bg-white p-6 rounded-lg border border-gray-200 shadow-md max-w-4xl mx-auto" data-id="element-387">
          <div className="flex items-start" data-id="element-388">
            <InfoIcon className="h-6 w-6 text-[#E5B3E5] mr-3 flex-shrink-0 mt-0.5" data-id="element-389" />
            <div data-id="element-390">
              <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-391">
                Need more storage?
              </h4>
              <p className="text-gray-600 mb-2" data-id="element-392">
                Additional storage available for $10 per 10GB.
              </p>
              <p className="text-gray-600 text-sm" data-id="element-393">
                Contact our team after subscribing to add extra storage to your
                plan.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-10 text-center bg-gray-50 py-6 rounded-lg max-w-3xl mx-auto" data-id="element-394">
          <p className="text-gray-600 font-medium" data-id="element-395">
            All plans include a 14-day free trial. No credit card required.
          </p>
        </div>
      </div>
    </section>;
}